import { Box, ButtonBase } from "@mui/material";
import { PropsWithChildren, ReactNode } from "react";
import { gutter } from "./MobileSheet";

// MobileFieldRow is one field of the task sheet: an icon, and the value beside it. A
// row with onClick is tapped to edit. An action is a button at the row's right end,
// which is tapped for something of its own.
export function MobileFieldRow(props: PropsWithChildren<{
    icon: ReactNode;
    onClick?: () => void;
    action?: ReactNode;
}>) {
    const content = (
        <>
            <Box sx={{ color: "action.active", display: "flex", pt: 1.5, flexShrink: 0 }}>{props.icon}</Box>
            <Box sx={{ flex: 1, minWidth: 0, py: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                {props.children}
            </Box>
        </>
    );

    const sx = {
        display: "flex",
        alignItems: "flex-start",
        gap: 2,
        minHeight: 48,
        width: "100%",
        textAlign: "left",
        px: `${gutter}px`,
        borderBottom: 1,
        borderColor: "divider",
    } as const;

    if (!props.onClick) return <Box sx={sx}>{content}</Box>;
    if (!props.action) return <ButtonBase onClick={props.onClick} sx={sx}>{content}</ButtonBase>;

    // the action sits beside the button rather than inside it, since a button can't
    // hold another
    return (
        <Box sx={{ display: "flex", alignItems: "stretch", borderBottom: 1, borderColor: "divider" }}>
            <ButtonBase onClick={props.onClick} sx={{ ...sx, borderBottom: 0, flex: 1, pr: 0 }}>{content}</ButtonBase>
            <Box sx={{ display: "flex", alignItems: "center", pr: `${gutter - 8}px` }}>{props.action}</Box>
        </Box>
    );
}
